import { defineStore } from 'pinia'

import ConfigApi from '@/api/config.js'

export const useUiStore = defineStore('ui', {
  state: () => ({
    isCustomerMode: false,
    isMaintenanceMode: false,
    isLiteUserMode: false,
    showLogin: false,
    showStream: false,
  }),

  actions: {
    async getConfig () {
      const res = await ConfigApi.getUiConfig()

      if (res.ok) {
        const config = await res.json()
        this.showLogin = config.show_login || false
        this.showStream = config.show_stream || false
        this.isMaintenanceMode = config.maintenance_mode || false
      }
    },
  },
})
